import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProgramDirectorService } from '../services/program-director.service';

/**
 * Prevents access to the edit-program page when the program has a pending revision.
 * Redirects to /director if a revision exists or the program is not found.
 */
export const EditProgramGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const programDirectorService = inject(ProgramDirectorService);

  const programNumber = route.paramMap.get('programNumber');
  if (!programNumber) {
    router.navigate(['/director']);
    return false;
  }

  return programDirectorService.getProgramsWithRevisions([{ programNumber }]).pipe(
    map(response => {
      const hasRevision = response?.data?.some(p => p.program_id == programNumber);
      if (hasRevision) {
        router.navigate(['/director']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/director']);
      return of(false);
    })
  );
};
